import { type VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';

import { cn } from '../../lib/utils';
import { statusDotVariants } from './variants';

function StatusDot({
  className,
  variant = 'active',
  ...props
}: ComponentProps<'div'> & VariantProps<typeof statusDotVariants>) {
  return (
    <div
      data-slot={'status-dot'}
      className={cn(statusDotVariants({ variant }), className)}
      {...props}
    />
  );
}

export { StatusDot };
